/* eslint-disable max-lines */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-lines */
import {
  Card,
  Group,
  Modal, Progress, SimpleGrid, Text
} from '@mantine/core';
import React, { useContext, useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import BadgeStatus from '../../components/elements/BadgeStatus';
import Banner from '../../components/elements/Banner';
import Button from '../../components/elements/Button';
import ErrorHandler from '../../components/elements/ErrorHandler';
import Maps from '../../components/elements/Maps';
import FormReason from '../../components/forms/FormReason';
import IconAccept from '../../components/icons/IconAccept';
import IconFailed from '../../components/icons/IconFailed';
import IconReject from '../../components/icons/IconReject';
import { AppContext } from '../../contexts';
import { getUserData } from '../../utils/storage';
import { clearDetail, setMerchantVerificationFilter, submitApprove, submitProcess, submitReject, submitRevition } from './actions';
import { icon, label, type } from './constants';
import styles from './styles.scoped.css';

export function Component() {
  // const { id } = useParams();
  const navigate = useNavigate();
  let progressRef = useRef(0);
  let countRef = useRef(0);
  const dispatch = useDispatch();
  const { setBreadcrumbs } = useContext(AppContext);
  const [modalRevition,setModalRevition] = useState({});
  const [modalApprove,setModalApprove] = useState({});
  const [modalReject,setModalReject] = useState({});
  const [afterSubmit, setAfterSubmit] = useState(false);
  const [progress, setProgress] = useState(0);
  const [modalError, setModalError] = useState(false);
  const [messageError, setMessageError] = useState('');

  const {
    dataMerchantRegistrationDetail: datas,
    isLoadingMerchantRegistrationDetail,
    messageMerchantRegistrationDetail,
    dataSubmitRejected,
    isLoadingSubmitRejected,
    dataSubmitRevition,
    isLoadingSubmitRevition,
    dataSubmitApproved,
    isLoadingSubmitApproved,
    dataOnProcess,
    messageSubmitApproved,
    messageSubmitRejected,
    messageSubmitRevition,
    filter
  } = useSelector((s) => s.merchantVerification);

  const updateFilter = { ...filter, registrationStatus: '' };
  useEffect(() => {
    setBreadcrumbs(['Verifikasi Data Pangkalan LPG 3 Kg']);
  }, []);

  useEffect(() => {
    if((messageSubmitApproved && !isLoadingSubmitApproved)
    || (messageSubmitRejected && !isLoadingSubmitRejected)
    || (messageSubmitRevition && !isLoadingSubmitRevition)){
      setModalError(true);
      setModalApprove({});
      setMessageError(messageSubmitApproved || messageSubmitRejected || messageSubmitRevition);
    }
  },[messageSubmitApproved, isLoadingSubmitApproved,
    messageSubmitRejected, isLoadingSubmitRejected,
    messageSubmitRevition, isLoadingSubmitRevition
  ]);

  useEffect(()=> {
    if(dataSubmitRejected && !isLoadingSubmitRejected){
      setModalReject({});
      fecthProcess();
    }
  },[dataSubmitRejected, isLoadingSubmitRejected]);

  useEffect(()=> {
    if(dataSubmitRevition && !isLoadingSubmitRevition){
      setModalRevition({});
      fecthProcess();
    }
  },[dataSubmitRevition, isLoadingSubmitRevition]);

  useEffect(()=> {
    if(dataSubmitApproved && !isLoadingSubmitApproved){
      setModalApprove({});
      fecthProcess();
    }
  },[dataSubmitApproved, isLoadingSubmitApproved]);

  useEffect(() => {
    if(afterSubmit){
      setAfterSubmit(false);
    }
  },[afterSubmit]);

  if (isLoadingMerchantRegistrationDetail) {
    return null;
  }

  if (messageMerchantRegistrationDetail) {
    return <ErrorHandler message={messageMerchantRegistrationDetail} />;
  }

  const fecthProcess = () => {
    countRef.current = countRef.current+1;
    progressRef.current = countRef.current/datas.length*100;
    setProgress(progress);
    const registrationId = datas.map(object => {
      return object.registrationId;
    });
    if(countRef.current === datas.length && datas.length > 1){
      dispatch(clearDetail());
      dispatch(setMerchantVerificationFilter(updateFilter));
      navigate('/merchant/verifikasi-data-merchant');
    }else{
      dispatch(submitProcess({ registrationId }, true));
    }
  };

  const handleapproved = () => {
    dispatch(submitApprove(modalApprove?.data?.registrationId));
  };

  const renderInfo = (label, data) => (
    <SimpleGrid cols={2}>
      <div className={styles.label}>{label}</div>
      <div>: {data}</div>
    </SimpleGrid>
  );

  const renderModalReject = () => {
    return(
      <Modal
        centered
        opened={modalReject?.open}
        size={'lg'}
        withCloseButton={false}
      >
        <div className={styles.containerModal}>
          <h5>Tolak Pangkalan LPG 3 Kg</h5>
          <span>
          Apakah Anda yakin untuk tolak data <b>{modalReject?.data?.storeName}</b>?
          </span>
          <FormReason
            dataModal={modalReject}
            labelBtn={'Kirim'}
            labelTextInput={'Alasan Penolakan'}
            onCloseModal={() => setModalReject({ open: false })}
            onSubmit={(values) =>
              dispatch(submitReject(values, modalReject?.data?.registrationId,
                setAfterSubmit(true)))
            }
            placeholder={'Tulis alasan penolakan'}
          />
        </div>
      </Modal>
    );
  };

  const renderModalRevition = () => {
    return(
      <Modal
        centered
        opened={modalRevition?.open}
        size={'lg'}
        withCloseButton={false}
      >
        <div className={styles.containerModal}>
          <h5>Perlu Perbaikan Data</h5>
          <span>
          Apakah Anda yakin mengirimkan
          email kepada <b>{modalRevition?.data?.storeName}</b> untuk melakukan perbaikan data?
          </span>
          <FormReason
            dataModal={modalRevition}
            labelBtn={'Kirim'}
            labelTextInput={'Alasan untuk melakukan perbaikan data'}
            onCloseModal={() => setModalRevition({ open: false })}
            onSubmit={(values) =>
              dispatch(submitRevition(values, modalRevition?.data?.registrationId,
                setAfterSubmit(true)))
            }
            placeholder={'Tulis alasan'}
          />
        </div>
      </Modal>
    );
  };


  const renderModalApprove = () => {
    return(
      <Modal
        centered
        onClose={() => setModalApprove({ open: false })}
        opened={modalApprove?.open}
        size={'lg'}
        withCloseButton={false}
      >
        <div className={styles.containerModal}>
          <h5>Menyetujui Pangkalan LPG 3 Kg</h5>
          <span>
        Pilih salah satu opsi untuk mengirimkan credential Pangkalan LPG 3 kg.
        Anda dapat memilih untuk mengirimkan melalui email atau melalui nomor Ponsel.
          </span>
        </div>
        <div className={styles.containerButton}>
          <Button
            className={styles.btnPrimary}
            onClick={handleapproved}
            style={'blue'}>
            Email
          </Button>
          <Button
            className={styles.btnPrimary}
            disabled={true}
            onClick={handleapproved}
            style={'blue'}>
            No. Ponsel
          </Button>
        </div>
      </Modal>
    );
  };

  const renderModalError = () => {
    return(
      <Modal
        centered
        onClose={() => setModalError(false)}
        opened={modalError}
        size={'lg'}
        withCloseButton={false}
      >
        <div className={styles.containerModal}>
          <h5>Gagal Memverifikasi Pangkalan LPG 3 Kg</h5>
          <span className={styles.containererror}>
            <IconFailed/>
            {messageError}
          </span>
        </div>
        <Button
          className={styles.btnClose}
          onClick={() => setModalError(false)}
          style={'blue'}>
            Tutup
        </Button>
      </Modal>
    );
  };
  return (
    <main>
      {datas.length > 1 &&
      <Card mb={24} radius="md" withBorder>
        <div className={styles.row}>
          <span className={styles.badgeInfo}>{countRef.current}</span>
          <Progress value={progressRef.current} />
          <span className={styles.badgeInfo}>{datas.length}</span>
        </div>
        <div style={{ display:'flex', justifyContent: 'center', alignItems: 'center' }}>
          <span className={styles.badgeInfo}>
            {countRef.current} dari {datas.length}</span> data telah Anda verifikasi
        </div>
      </Card>
      }

      {datas.map((data, index) =>{
        const centerPoint = {
          lat: parseFloat(data.coordinate?.split(',')[0]),
          lng: parseFloat(data.coordinate?.split(',')[1])
        };
        return(
          <div key={index}>
            {data.registrationStatus !== 'Sedang Diproses' && dataOnProcess && datas.length > 1 ?
              <Banner
                desc={`${label[data.registrationStatus]} ${data.storeName}`}
                icon={icon[data.registrationStatus]}
                type={type[data.registrationStatus]}
              />
              :<>
                <div className={styles.cardTitle}>
                  <h5>{data.storeName}</h5>
                </div>
                <Card key={data.registrationId} mb={24} radius="md"  withBorder>
                  <Card.Section inheritPadding py="xs">
                    <Text weight={500}>Data Pangkalan LPG 3 Kg</Text>
                  </Card.Section>
                  <SimpleGrid  cols={2}>
                    <div>
                      {renderInfo('Tanggal Registrasi', data.registrationDate)}
                      {renderInfo('Jam Registrasi', data.registrationTime)}
                      {renderInfo('ID Agen', `${data?.agen?.id} - ${data?.agen?.name}`)}
                      {renderInfo('Wave', data.wave)}
                      {renderInfo('MID', data.midMap)}
                    </div>
                    <div>
                      {renderInfo('MID LinkAja', data.mid === '-' ?
                        <BadgeStatus label={'Belum Aktivasi'}/> : data.mid)}
                      {renderInfo('Nama Pemilik', data.ownerName)}
                      {renderInfo('No. KTP Pemilik', data.nationalityId)}
                      {renderInfo('No. Ponsel Pemilik', data.phoneNumber)}
                      {renderInfo('No. Telepon Pangkalan LPG 3 Kg', data.storePhoneNumber)}
                      {renderInfo('Email Pemilik', data.email)}
                    </div>
                  </SimpleGrid>
                  <Card.Section inheritPadding py="xs">
                    <Text weight={500}>Alamat Pangkalan LPG 3 Kg</Text>
                  </Card.Section>
                  <SimpleGrid  cols={2}>
                    <div>
                      {renderInfo('Provinsi', data.provinceName)}
                      {renderInfo('Kota/Kabupaten', data.cityName)}
                      {renderInfo('Kecamatan', data.districtName)}
                      {renderInfo('Kelurahan', data.villageName)}
                    </div>
                    <div>
                      {renderInfo('Kode Pos', data.zipcode)}
                      {renderInfo('Alamat', data.street)}
                    </div>
                  </SimpleGrid>
                  {(data.registrationStatus === 'Sedang Diproses' ||
              data.registrationStatus === 'Perlu Diproses')
              && data.reviewerId === getUserData()?.adminId ? (
                      <Card.Section className={styles.cardFooter}
                        inheritPadding mt="sm" pb="md" pt={'md'} withBorder>
                        <Button className={styles.revisi}
                          onClick={() => {setModalRevition({ open: true, data });}}
                          style={'blue'}>
                            Perlu Perbaikan Data
                        </Button>
                        <div className={styles.column}  >
                          <Button className={styles.approve}
                            onClick={() => setModalApprove({ open: true, data })}
                            style={'success'}>
                            <span className={styles.btnIcon}><IconAccept/> Setuju</span>
                          </Button>
                          <Button className={styles['reject']}
                            onClick={() => setModalReject({ open: true, data })}
                            style={'danger'}>
                            <span className={styles.btnIcon}><IconReject/> Tolak</span>
                          </Button>
                        </div>
                      </Card.Section>
                    ) : '' }
                </Card>
              </>
            }
            {datas.length === 1 &&
            <>
              <Card className={styles.cardStatus} py={0} radius="md" withBorder>
                <div className={styles.colomnStatus}>
                  <div className={styles.containerStatus}>
                    <span>Status Verifikasi</span>
                    <span><BadgeStatus label={data.registrationStatus}/></span>
                  </div>
                  <div className={styles.containerStatus}>
                    <span>Tanggal Status</span>
                    <span>{data.updatedAt}</span>
                  </div>
                  <div className={styles.containerStatus}
                    style={{ borderRight: '1px solid #D9DEE4', borderLeft: '1px solid #D9DEE4' }}>
                    <span>Petinjau</span>
                    <span>{data.reviewer}</span>
                  </div>
                  <div className={styles.containerStatus}>
                    <span>Alasan</span>
                    <span>{data.reason}</span>
                  </div>
                </div>
              </Card>
              <Card radius="md" withBorder >
                <Card.Section inheritPadding py="xs">
                  <Group position="apart">
                    <Text weight={500}>Titik Koordinat</Text>
                    <Text>{data.coordinate}</Text>
                  </Group>
                </Card.Section>
                <div style={{ height: '300px' }}>
                  <Maps centerPoint={centerPoint} />
                </div>
              </Card>
            </>
            }
          </div>
        );}
      )}
      {renderModalReject()}
      {renderModalApprove()}
      {renderModalRevition()}
      {renderModalError()}
    </main>
  );
}


export default Component;
